/**
 * @typedef {Object} DataLayerProduct
 * @property {string} id
 * @property {string} name
 * @property {string} price
 * @property {string} brand
 * @property {string} category
 * @property {string} categoryId
 * @property {string} variant
 * @property {string} quantity
 * @property {string} count
 */

/**
 * @typedef {Object} OrderData
 * @property {string | undefined} id - order id
 * @property {string} email - user email (from registered user)
 * @property {string} userName - user name (from filled fields)
 * @property {string} userEmail - user email (from filled fields)
 * @property {string} price - order total price
 * @property {string} revenue - order total price
 * @property {string} shipping - delivery price
 * @property {string} coupon - applied coupon
 */

/**
 * Create global data layer variable
 * @type {Object[]}
 */
window['dataLayer'] = window['dataLayer'] || [];

import { createOpenCheckout } from './create-open-checkout.js';
import { createCheckoutPaymentSelect } from './create-checkout-payment-select.js';
import { createCheckoutDeliverySelect } from './create-checkout-delivery-select.js';
import { createCheckoutConfirmationPage } from './create-checkout-confirmation-page.js';
import { createHomepage } from './create-homepage.js';
import { createProductList } from './create-product-list.js';
import { createProductClick } from './create-product-click.js';
import { createDetailPage } from './create-detail-page.js';
import { createDetailPageProductAdd } from './create-detail-page-product-add.js';
import { createDetailReserve } from './create-detail-reserve.js';
import { createProductChange } from './create-product-change.js';
import { createProductAdd } from './create-product-add.js';
import { createProductRemove } from './create-product-remove.js';
import { createBasketOpen } from './create-basket-open.js';
import { createCheckoutFinish } from './create-checkout-finish.js';
import { productAddData } from './product-add-data.js';
import { createAdmitad } from './create-admitad.js';
import { storeUtmToCookie } from './utm.js';
import { storeUserEmail } from './authenticated-user.js';

export {
    createHomepage,
    createProductList,
    createProductClick,
    createOpenCheckout,
    createCheckoutPaymentSelect,
    createCheckoutDeliverySelect,
    createCheckoutConfirmationPage,
    createProductChange,
    createProductAdd,
    createProductRemove,
    createBasketOpen,
    productAddData,
    createDetailPageProductAdd,
    createDetailReserve,
    createDetailPage,
    createCheckoutFinish,
    createAdmitad,
    storeUtmToCookie,
    storeUserEmail,
}
